var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frmdashboard_epkartya_formcont"},[_c('GrcDB',{ref:"GRCDB"}),_c('GrcDialog',{ref:"Dialog"}),_c('div',{staticClass:"frmdashboard_epkartya_itemcont",domProps:{"innerHTML":_vm._s(_vm.HtmlContent)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }